import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    initialDate: String
  }

  connect() {
    if (this.hasInitialDateValue) {
      this.loadSlots(this.initialDateValue)

      // Highlight the date if visible
      const dateEl = this.element.querySelector(`[data-date="${this.initialDateValue}"]`)
      if (dateEl) {
        this.highlightDate(dateEl)
      }
    }
  }

  selectDate(event) {
    const date = event.currentTarget.dataset.date
    this.highlightDate(event.currentTarget)
    this.loadSlots(date)
  }

  highlightDate(element) {
    this.element.querySelectorAll('[data-date]').forEach(el => {
      el.classList.remove('ring', 'ring-primary', 'ring-offset-2')
    })
    element.classList.add('ring', 'ring-primary', 'ring-offset-2')
  }

  loadSlots(date) {
    // Get altcha payload
    const altchaWidget = document.querySelector('altcha-widget')
    const altchaPayload = altchaWidget ? altchaWidget.getAttribute('payload') : null

    // Fetch slots using POST to send altcha payload
    const formData = new FormData()
    formData.append('date', date)
    if (altchaPayload) {
      formData.append('altcha', altchaPayload)
    }

    fetch(this.urlValue, {
      method: 'POST',
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
      },
      body: formData
    })
    .then(response => response.text())
    .then(html => {
      const slotsContainer = document.getElementById("slots-container")
      slotsContainer.innerHTML = html

      // Scroll to the slots container smoothly
      slotsContainer.scrollIntoView({ behavior: 'smooth', block: 'start' })
    })
  }
}
